export default angular
  .module('app.conf')
  .constant('HoldingEnvironment', {
    domain: 'goldmoney.com',
    env: 'production',
    settings: {
      debug: false,
      log: {
        debug: false,
      },
    },
    tokens: {
      strapiAccessToken: `ceaa0711d00a8bc20da446e4903df8dfd91d9a88e61bdccd2e8412119a07e9e2bf502a22e64314fdb4fd233b3020461fb8f6be5c2e82b30d1072843093eec0238e4568d83b561ade6318b8d089cb7439baaa00bd979d63c013c81f0979e643ca475a6f714a045031a78d71a63629ecab29022d9210f84b84e92ececa1807a733`
    },
    urls: {
      backend: 'https://wealth-api.goldmoney.com/',
      clientAgreement: {
        main: 'https://www.goldmoney.com/client-agreement',
        regulator: {
          canada: 'https://www.goldmoney.com/docs/goldmoney-client-agreement-canada.pdf',
          uk: 'https://www.goldmoney.com/docs/goldmoney-client-agreement-uk.pdf',
        },
      },
      disclaimer: 'https://www.goldmoney.com/disclaimer',
      documents: {
        mailVerification: 'https://gm-public.s3.eu-west-1.amazonaws.com/docs/onboarding/verification-individual-holding.pdf',
        postIdentVerification: 'https://gm-public.s3.eu-west-1.amazonaws.com/docs/onboarding/verification-postident-antragsunterlagen.pdf',
      },
      marketSummary: 'market-summary.goldmoney.com',
      privacy: 'https://www.goldmoney.com/privacy-policy',
      referral: {
        terms: 'https://www.goldmoney.com/docs/goldmoney-referral-program-terms.pdf',
      },
      research: 'https://www.goldmoney.com/research/goldmoney-insights',
      riskDisclosure: 'https://www.goldmoney.com/docs/goldmoney-risk-disclosure-statement.pdf',
      site: 'https://www.goldmoney.com',
      strapi: 'https://data.goldmoney.com/api',
      support: {
        buy: {
          fixed: 'https://support.goldmoney.com/hc/articles/360000744207',
          limits: 'https://support.goldmoney.com/hc/articles/360000737568',
        },
        funding: {
          main: 'https://support.goldmoney.com/hc/sections/115004131728',
          trust: 'https://support.goldmoney.com/hc/articles/360000686667',
        },
        main: 'https://support.goldmoney.com/hc',
        onboarding: {
          countries: 'https://support.goldmoney.com/hc/articles/360000844487',
          documents: 'https://support.goldmoney.com/hc/articles/360000849727',
          id: 'https://support.goldmoney.com/hc/articles/360000854208',
          joint: 'https://support.goldmoney.com/hc/articles/360000844387',
          por: 'https://support.goldmoney.com/hc/articles/360000845247',
          postident: 'https://support.goldmoney.com/hc/articles/360000910308',
          residency: 'https://support.goldmoney.com/hc/articles/360000845527',
          unverified: 'https://support.goldmoney.com/hc/articles/360000849727',
        },
        physical: {
          overview: 'https://support.goldmoney.com/hc/en-us/articles/360025277972',
        },
        redemption: {
          countries: 'https://support.goldmoney.com/hc/articles/360000697747',
          possession: 'https://support.goldmoney.com/hc/articles/360000707848',
          tax: 'https://support.goldmoney.com/hc/articles/360000707868',
        },
        registration: {
          what: 'https://support.goldmoney.com/hc/articles/360000697687',
          difference: 'https://support.goldmoney.com/hc/articles/360000707988',
        },
        sell: {
          fixed: 'https://support.goldmoney.com/hc/articles/360000744207',
          limits: 'https://support.goldmoney.com/hc/articles/360000737568',
        },
        storage: 'https://support.goldmoney.com/hc/sections/360000095347',
        storageRegistered: 'https://support.goldmoney.com/hc/articles/360000668307',
      },
    },
  })
  .name;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/conf/constants/environment-production.js